import React from 'react';
import { useTranslation } from 'react-i18next';
import './announcementDetails.css';
import { Alert, Form } from 'react-bootstrap';
import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PreloaderComponent from '../../commons/preloader/preloaderComponent';
import {
    announcementTypeString,
    platformString,
} from '../../../utils/announcements';
import DatePicker, { registerLocale } from 'react-datepicker';
import fi from 'date-fns/locale/fi';

registerLocale('fi', fi);

const AnnouncementDetailsView = ({
    announcement,
    handleInputChange,
    handleFocusChange,
    changeContentFI,
    changeContentEN,
    quillModules,
    save,
    message,
    success,
    publish,
    isLoading,
    deleteAnnouncement,
    archive,
    duplicate,
    makeTemplate,
    publishType,
    setPublishType,
    changePublishDate,
    handlePlatformChange,
    platforms,
    types,
    uploadAttachment,
    removeAttachment,
    canSendAnnouncement
}) => {
    const { t, i18n } = useTranslation();
    // 'en' is react-datepicker's built-in default; everything else falls
    // back to Finnish alongside the app locales.
    const datePickerLocale = i18n.language?.startsWith('en') ? 'en' : 'fi';

    return (
        <div className="announcement-form">
            <div className="buttons-row">
                <p> </p>
                <div className="destructive-buttons">
                    <button
                        className="btn btn-success"
                        type="button"
                        onClick={() => archive()}
                        disabled={announcement.status === 'archived'}
                    >
                        {t('adminAnnouncementDetails.archive')}
                    </button>
                    <button
                        className="btn btn-success"
                        type="button"
                        onClick={() => makeTemplate()}
                        disabled={announcement.status === 'template'}
                    >
                        {t('adminAnnouncementDetails.makeTemplate')}
                    </button>
                    <button
                        className="btn btn-success"
                        type="button"
                        onClick={() => duplicate()}
                    >
                        {t('adminAnnouncementDetails.duplicate')}
                    </button>
                </div>
            </div>
            <ValidationForm
                onSubmit={(e) => {
                    e.preventDefault();
                    save();
                }}
            >
                {' '}
                <Form.Group>
                    <Form.Label>
                        <b>{t('adminAnnouncementDetails.typeLabel')}</b>
                    </Form.Label>
                    <Form.Control
                        as="select"
                        name="type"
                        value={announcement.type}
                        required
                        errorMessage={{
                            required: t(
                                'adminAnnouncementDetails.typeRequired'
                            ),
                        }}
                        onChange={handleInputChange}
                    >
                        {types.map((type) => (
                            <option value={type} key={type}>
                                {announcementTypeString(type)}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        <b>{t('adminAnnouncementDetails.titleLabel')}</b> FI
                    </Form.Label>
                    <TextInput
                        name="titleFI"
                        id="titleFI"
                        defaultValue={announcement.titleFI}
                        errorMessage={{
                            required: t('adminAnnouncementDetails.titleRequired'),
                            pattern: t('adminAnnouncementDetails.titleInvalid'),
                        }}
                        required
                        pattern="[a-zA-Z\u00c0-\u017e- ]$"
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        <b>{t('adminAnnouncementDetails.titleLabel')}</b> EN
                    </Form.Label>
                    <TextInput
                        name="titleEN"
                        id="titleEN"
                        defaultValue={announcement.titleEN}
                        errorMessage={{
                            required: t('adminAnnouncementDetails.titleRequired'),
                            pattern: t('adminAnnouncementDetails.titleInvalid'),
                        }}
                        required
                        pattern="[a-zA-Z\u00c0-\u017e- ]$"
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        <b>{t('adminAnnouncementDetails.contentLabel')}</b> FI
                    </Form.Label>
                    <ReactQuill
                        theme="snow"
                        value={announcement.contentFI}
                        onChange={changeContentFI}
                        onFocus={handleFocusChange}
                        modules={quillModules}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        <b>{t('adminAnnouncementDetails.contentLabel')}</b> EN
                    </Form.Label>
                    <ReactQuill
                        theme="snow"
                        value={announcement.contentEN}
                        onChange={changeContentEN}
                        onFocus={handleFocusChange}
                        modules={quillModules}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        <b>{t('announcements.attachments')}</b>
                    </Form.Label>
                    <div className="attachments-col">
                        <div className="attachments-row">
                            {announcement.attachments.map((attachment) => (

                                <div
                                    className="single-attachment"
                                    key={attachment}
                                >
                                    <p>{attachment.name}</p>
                                    <p
                                        className="remove"
                                        onClick={() =>
                                            removeAttachment(attachment)
                                        }
                                    >
                                        x
                                    </p>
                                </div>
                            ))}
                        </div>
                        <label
                            for="file-picker"
                            className="btn btn-success file-picker-button"
                        >
                            {t('adminAnnouncementDetails.chooseFile')}
                        </label>
                        <input
                            type="file"
                            id="file-picker"
                            onChange={uploadAttachment}
                        ></input>
                    </div>
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        <b>{t('adminAnnouncementDetails.platformsLabel')}</b>
                    </Form.Label>
                    {platforms.map((platform) => (
                        <Form.Check
                            type="checkbox"
                            key={platform}
                            checked={announcement.platforms.includes(platform)}
                            onChange={handlePlatformChange}
                            name={platform}
                            label={platformString(platform)}
                        />
                    ))}
                </Form.Group>
                {announcement.status === 'published' && (
                    <p>{t('adminAnnouncementDetails.noticePublished')}</p>
                )}
                {announcement.status === 'template' && (
                    <p>{t('adminAnnouncementDetails.noticeTemplate')}</p>
                )}
                {announcement.status === 'archived' && (
                    <p>{t('adminAnnouncementDetails.noticeArchived')}</p>
                )}
                {announcement.status === 'scheduled' && (
                    <p>{t('adminAnnouncementDetails.noticeScheduled')}</p>
                )}
                {(announcement.status === 'draft' ||
                    announcement.status === 'scheduled') && (
                    <>
                        {' '}
                        <Form.Group>
                            <Form.Label>
                                <b>{t('adminAnnouncementDetails.publishTimeLabel')}</b>
                            </Form.Label>
                            <Form.Control
                                as="select"
                                name="publishType"
                                value={publishType}
                                onChange={(e) => setPublishType(e.target.value)}
                            >
                                <option value="now">
                                    {t('adminAnnouncementDetails.publishNow')}
                                </option>
                                <option value="scheduled">
                                    {t('adminAnnouncementDetails.publishScheduled')}
                                </option>
                            </Form.Control>
                        </Form.Group>
                        {publishType === 'scheduled' && (
                            <Form.Group>
                                <Form.Label>
                                    <b>{t('adminAnnouncementDetails.publishDateLabel')}</b>
                                </Form.Label>
                                <DatePicker
                                    selected={
                                        new Date(announcement.publishedAt)
                                    }
                                    required
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    onChange={changePublishDate}
                                    timeIntervals={15}
                                    dateFormat="dd.MM.yyyy HH:mm"
                                    className="form-control"
                                    locale={datePickerLocale}
                                />
                            </Form.Group>
                        )}
                    </>
                )}
                {message && !success ? (
                    <Alert variant={!success ? 'danger' : 'success'}>
                        {t(message.key, message.params)}
                    </Alert>
                ) : null}
                <div className="buttons-row">
                    <Link
                        className="btn btn-secondary secondary"
                        to={`/admin/announcements`}
                    >
                        {t('common.back')}
                    </Link>
                    {isLoading && <PreloaderComponent />}
                    <div className="destructive-buttons">
                        <button
                            className="btn btn-success danger"
                            type="button"
                            onClick={() => deleteAnnouncement()}
                        >
                            {t('adminAnnouncementDetails.delete')}
                        </button>
                        <button className="btn btn-success" type="submit">
                            {t('adminAnnouncementDetails.save')}
                        </button>
                        <button
                            className="btn btn-success"
                            type="button"
                            onClick={() => publish()}
                            disabled={!canSendAnnouncement()}
                        >
                            {publishType === 'now'
                                ? t('adminAnnouncementDetails.publish')
                                : t('adminAnnouncementDetails.schedule')}
                        </button>
                    </div>
                </div>
            </ValidationForm>
        </div>
    );
};

export default AnnouncementDetailsView;
